import styled, { css } from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const HeaderWrapper = styled.div`
  background: #15aee5;
  display: flex;
  justify-content: space-between;
  padding: 1.375rem;
`;

export const Title = styled.h2`
  font-size: 1.125rem;
  color: white;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  text-transform: initial;
`;

export const FormBody = styled.div`
  max-height: 60vh;
  padding: 0 1.375rem;
  overflow-y: auto;
`;

export const OptionsWrapper = styled.div`
  padding: 1.375rem;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: ${(props) => props.align ?? "center"};
  > div {
    margin-right: 1rem;
  }
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.375rem;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column};
  gap: 1.25rem;
  margin-bottom: ${(props) => props.marginBottom ?? "10px"};
`;

export const MainTitleText = styled.h2`
  color: #474747;
  font-size: 18px;
  font-family: lato;
  text-transform: initial;
  margin-bottom: 10px;
  line-height: 1;
  margin-top: -3px;
  font-weight: normal;
`;
export const ReasonText = styled.span`
  justify-self: auto;
  color: #474747;
  font-weight: bold !important;
`;

export const QuestionText = styled.div`
  justify-self: auto;
  color: #15aee5;
  font-size: 14px;
  font-weight: bold !important;
  ::after {
    content: "*";
    color: #ea6457;
    font-weight: bold;
  }
`;

export const CancelText = styled.div`
  justify-self: auto;
  color: #474747;
  font-size: 14px;
  font-weight: normal;
`;

export const ToggleText = styled.span`
  justify-self: auto;
  color: #474747;
  font-size: 14px;
  font-weight: normal;
`;

export const RequiredMessage = styled.p`
  width: 100%;
  color: red;
  font-size: 0.875rem;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  padding: 0;
`;

export const ErrorDiv = styled.div`
  height: 35px;
  border: solid 1px red;
  padding: 7px;
`;

export const ContactContainer = styled.div`
  height: auto;
`;

export const ContactButton = styled(BaseButton)`
  border: 1px solid #00aeea;
  background: #00aeea;
  font-weight: normal;
  width: auto;
  margin-right: 10px;
`;

export const LabelText = styled.label`
  font-family: Lato;
  font-size: 1rem;
  font-style: normal;
  font-weight: 700 !important;
  left: 0.625rem;
  line-height: 1;
  text-transform: none;
  top: 0.625rem;
  width: auto;
  ::after {
    content: "*";
    color: #ea6457;
    font-weight: bold;
  }
`;

export const QuoteText = styled.div`
  font-family: Lato;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400 !important;
  left: 0.625rem;
  line-height: 1;
  text-transform: none;
  top: 0.625rem;
  width: auto;
  color: #474747;
`;
